"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _KansaReportSearchCondition = _interopRequireDefault(require("./components/KansaReportSearchCondition"));
var _KansaReportSearchResult = _interopRequireDefault(require("./components/KansaReportSearchResult"));
var _kansaReportActions = require("./kansaReportActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査報告書検索画面
 */
class KansaReportSearchMain extends _react.default.Component {
  constructor(props) {
    super(props);
    if (props.shareCondition.init) {
      props.applyCondition(props.shareCondition);
    }
  }
  componentDidMount() {
    const {
      scrollY,
      noSticky
    } = this.props.scrollTop;
    if (noSticky) {
      _windowUtil.default.windowScroll(scrollY);
    } else {
      window.scrollTo(0, 0);
    }
  }
  render() {
    const {
      intl,
      searchResult,
      paging,
      goRegister,
      resetPaging,
      changePage,
      changeViewNum,
      scrollTop,
      onScroll,
      pms
    } = this.props;
    const onRegistClick = userInfo => {
      goRegister(userInfo);
    };
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_REPORT_SEARCH
      })
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_KansaReportSearchCondition.default, {
      pms: pms
    }), /*#__PURE__*/_react.default.createElement(_KansaReportSearchResult.default, {
      searchResult,
      onRegistClick,
      paging,
      resetPaging,
      changePage,
      changeViewNum,
      scrollTop,
      onScroll
    })));
  }
}
const mapStateToProps = state => {
  return {
    searchResult: state.kansaReport.searchResult,
    paging: state.kansaReport.main.paging,
    scrollTop: state.kansaReport.main.scrollTop,
    shareCondition: state.kansaShareCondition
  };
};
const mapDispatchToProps = dispatch => {
  return {
    goRegister: userId => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_REGISTER](userId)),
    resetPaging: () => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.RESET_PAGING]()),
    changePage: currentPage => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CHANGE_PAGE](currentPage)),
    changeViewNum: viewNum => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CHANGE_VIEW_NUM](viewNum)),
    changeShowAll: soshikiShowAll => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CHANGE_SHOW_ALL](soshikiShowAll)),
    onScroll: scrollTop => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CHANGE_SCROLL_TOP](scrollTop)),
    applyCondition: condition => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.APPLY_SHARE_CONDITION](condition))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(KansaReportSearchMain));